import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, signal } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { defaultRuntimeConfig, RuntimeConfig } from './runtime-config.model';
import { RUNTIME_CONFIG_PATH } from './runtime-config.token';

@Injectable({ providedIn: 'root' })
export class RuntimeConfigService {
  private readonly _config = signal<RuntimeConfig>(defaultRuntimeConfig);
  readonly config = this._config.asReadonly();

  constructor(
    private readonly http: HttpClient,
    @Inject(RUNTIME_CONFIG_PATH) private readonly runtimeConfigPath: string,
  ) {}

  async load(): Promise<void> {
    try {
      const remoteConfig = await firstValueFrom(
        this.http.get<Partial<RuntimeConfig>>(this.runtimeConfigPath),
      );

      this._config.set({
        ...defaultRuntimeConfig,
        ...remoteConfig,
        firebaseConfig: {
          ...defaultRuntimeConfig.firebaseConfig,
          ...remoteConfig.firebaseConfig,
        },
        featureFlags: {
          ...defaultRuntimeConfig.featureFlags,
          ...remoteConfig.featureFlags,
        },
      });
    } catch (error) {
      console.warn('Runtime config could not be loaded. Using defaults.', error);
      this._config.set(defaultRuntimeConfig);
    }
  }
}
